(function() {
  function initBuildingContactForm() {
    const emailInput = document.getElementById('ContactForm-building-email');
    const emailErrorMsg = document.getElementById('ContactForm-building-email-error');
    const emailLabel = emailInput ? document.querySelector('label[for="ContactForm-building-email"]') : null;
    const textarea = document.getElementById('ContactForm-building-body');
    const textareaLabel = textarea ? document.querySelector('label[for="ContactForm-building-body"]') : null;
    const contactForm = document.getElementById('ContactForm-building');

    if (!contactForm) {
      return;
    }

    function validateEmail(email) {
      const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
      return emailRegex.test(email);
    }

    function showEmailError(message) {
      if (emailErrorMsg && emailInput) {
        emailErrorMsg.textContent = message;
        emailErrorMsg.style.display = 'block';
        emailInput.parentElement.classList.add('has-error');
      }
    }

    function hideEmailError() {
      if (emailErrorMsg && emailInput) {
        emailErrorMsg.style.display = 'none';
        emailInput.parentElement.classList.remove('has-error');
      }
    }

    if (emailInput && emailLabel && emailLabel.classList.contains('building-floating-label')) {
      function checkEmailValue() {
        if (emailInput.value && emailInput.value.trim() !== '') {
          emailInput.parentElement.classList.add('has-value');
        } else {
          emailInput.parentElement.classList.remove('has-value');
        }
      }

      checkEmailValue();

      emailInput.addEventListener('focus', function() {
        emailInput.parentElement.classList.add('focused');
        hideEmailError();
      });

      emailInput.addEventListener('blur', function() {
        emailInput.parentElement.classList.remove('focused');
        checkEmailValue();

        const emailValue = emailInput.value.trim();
        if (emailValue && !validateEmail(emailValue)) {
          showEmailError('Email is invalid.');
        } else {
          hideEmailError();
        }
      });

      emailInput.addEventListener('input', function() {
        checkEmailValue();
        if (emailErrorMsg && emailErrorMsg.style.display === 'block') {
          const emailValue = emailInput.value.trim();
          if (validateEmail(emailValue)) {
            hideEmailError();
          }
        }
      });

      if (emailErrorMsg) {
        emailErrorMsg.addEventListener('click', function() {
          hideEmailError();
          emailInput.focus();
        });
      }
    }

    if (textarea && textareaLabel && textareaLabel.classList.contains('building-floating-label')) {
      function checkTextareaValue() {
        if (textarea.value && textarea.value.trim() !== '') {
          textarea.parentElement.classList.add('has-value');
        } else {
          textarea.parentElement.classList.remove('has-value');
        }
      }

      checkTextareaValue();

      textarea.addEventListener('focus', function() {
        textarea.parentElement.classList.add('focused');
      });

      textarea.addEventListener('blur', function() {
        textarea.parentElement.classList.remove('focused');
        checkTextareaValue();
      });

      textarea.addEventListener('input', function() {
        checkTextareaValue();
      });
    }

    if (contactForm.dataset.initialized) {
      return;
    }

    contactForm.dataset.initialized = 'true';

    let formConfig = {
      successNote: 'You have successfully subscribed',
      errorNote: 'Submission failed, please resubmit'
    };

    const configScript = document.getElementById('building-contact-form-config');
    if (configScript) {
      try {
        formConfig = JSON.parse(configScript.textContent);
      } catch (e) {
      }
    }

    const testErrorBtn = document.getElementById('test-building-error-btn');
    if (testErrorBtn) {
      testErrorBtn.addEventListener('click', function() {
        const formFields = contactForm.querySelectorAll('.building-contact__fields, .building-field-input, .building-contact__button');
        formFields.forEach(function(field) {
          field.style.display = 'none';
        });

        const errorDiv = document.createElement('div');
        errorDiv.className = 'building-form-message';
        const errorMessageDiv = document.createElement('div');
        errorMessageDiv.className = 'building-form-status-message building-form-status-error';
        errorMessageDiv.setAttribute('role', 'alert');
        errorMessageDiv.setAttribute('tabindex', '-1');

        const p = document.createElement('p');
        p.textContent = formConfig.errorNote;
        errorMessageDiv.appendChild(p);

        errorDiv.appendChild(errorMessageDiv);
        contactForm.insertBefore(errorDiv, contactForm.firstChild);

        setTimeout(function() {
          errorDiv.remove();
          formFields.forEach(function(field) {
            field.style.display = '';
          });
        }, 3000);
      });
    }

    const errorMessage = document.querySelector('.mt-building-contact-right .building-form-message');
    if (errorMessage && window.getComputedStyle(errorMessage).display !== 'none') {
      setTimeout(function() {
        const url = new URL(window.location.href);
        url.search = '';
        window.location.href = url.toString();
      }, 3000);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initBuildingContactForm);
  } else {
    initBuildingContactForm();
  }

  if (typeof Turbo !== 'undefined') {
    document.addEventListener('turbo:load', initBuildingContactForm);
  }

  if (typeof Turbolinks !== 'undefined') {
    document.addEventListener('turbolinks:load', initBuildingContactForm);
  }
})();
